export const ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_RELATED = 5;
